import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

CTA3.propTypes = {
    className: PropTypes.string, // Agrega className a las PropTypes
};

function CTA3(props) {
    const { className } = props; // Desestructura className de props

    return (
        <section className={`tf-section tf_CTA_2 ${className}`}> {/* Usa className aquí */}
            <div className="overlay">
                <img src="/assets/cerv/home/Shadow-VR-banner.webp" alt="" />
            </div>
            <div className="container relative">
                <div className="row">
                    <div className="col-md-9">
                        <div className="tf-title left mb0" data-aos="fade-up" data-aos-duration="800">
                            <h2 className="title">
                                Conviértete en nuestro socio potencial
                            </h2>
                            <p className="sub">Contactanos ahora para una demostración o tour de nuestras soluciones.</p>
                            <div className="wrap-btn">
                                <Link to="/contact" className="tf-button style3">
                                    Solicitar demostración
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="image_cta" data-aos="fade-left" data-aos-duration="1200">
                            <img className="move4" src="/assets/cerv/home/imgoculus-VR-inmersivo.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CTA3;